import {
  ApplicationConfig,
  importProvidersFrom,
  isDevMode,
} from '@angular/core';
import { provideRouter, withViewTransitions } from '@angular/router';
import { routes } from './app.routes';
import {
  vi_VN,
  provideNzI18n,
  NZ_I18N,
  NZ_DATE_LOCALE,
} from 'ng-zorro-antd/i18n';
import { DatePipe, registerLocaleData } from '@angular/common';
import vi from '@angular/common/locales/vi';
import { FormsModule } from '@angular/forms';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  HttpClient,
  HttpClientModule,
  provideHttpClient,
  withInterceptors,
} from '@angular/common/http';
import {
  AuthConfig,
  OAuthStorage,
  provideOAuthClient,
} from 'angular-oauth2-oidc';

import { authCodeFlowConfig } from '../environments/auth/auth-config';
import { provideStore } from '@ngrx/store';
import { reducers, metaReducers } from './store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
// import { Interceptor } from './core/interceptor/interceptor.interceptor';
import { JWT_OPTIONS, JwtHelperService } from '@auth0/angular-jwt';
import { Interceptor } from 'authen-service-library';
import { vi as viNZ } from 'date-fns/locale';
import { routerHandl } from '@core/services/routerHanld.service';

registerLocaleData(vi);
export function storageFactory(): OAuthStorage {
  return localStorage;
}
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(HttpClientModule),
    importProvidersFrom(
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient],
        },
      })
    ),
    provideRouter(routes, withViewTransitions()),
    provideNzI18n(vi_VN),
    importProvidersFrom(FormsModule),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([Interceptor])),
    provideAnimationsAsync(),
    provideOAuthClient(),
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: authAppInitializerFactory,
    //   deps: [AuthService],
    //   multi: true,
    // },
    {
      provide: AuthConfig,
      useValue: authCodeFlowConfig,
    },
    { provide: OAuthStorage, useFactory: storageFactory },
    { provide: JWT_OPTIONS, useValue: JWT_OPTIONS },
    JwtHelperService,
    { provide: NZ_DATE_LOCALE, useValue: viNZ },
    provideStore(reducers, { metaReducers }),
    provideAnimationsAsync(),
    provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    { provide: NZ_I18N, useValue: vi_VN },
    DatePipe,
    routerHandl
  ],
};
